import React from 'react';
import EN from '../../EN.json';
import FR from '../../FR.json';

const {
  USERS: {
    USER_AUTHENTICATION: {
      UPDATE_PASSWORD_SCHEMA:{
        SUCCESS_MESSAGE,
        NOTE
      }
    }
  }
} =  localStorage.getItem('locale') ? (localStorage.getItem('locale') === 'EN' ? EN : FR) : EN;
const SuccessMessage = () => {
  return (
    <>
      <div
        id="email_sent"
        className="informational_message"
        style={{ marginTop: 15 }}
      >
        <span
          className="frg-icon icon-warning-inverted"
          style={{
            fontSize: 14,
            color: '#66cc00',
            marginRight: 5
          }}
        />
        <span className="frg-body-font-14px">
          <b>{NOTE}</b>: {SUCCESS_MESSAGE}
        </span>
      </div>
    </>
  );
};

export default SuccessMessage;
